module.exports = __webpack_public_path__ + "static/img/arrow-down-selector.ed0cf37f.svg";